import { render, staticRenderFns } from "./TransactionRecordInfo.vue?vue&type=template&id=8b6231b6&scoped=true&"
import script from "./TransactionRecordInfo.vue?vue&type=script&lang=js&"
export * from "./TransactionRecordInfo.vue?vue&type=script&lang=js&"
import style0 from "./TransactionRecordInfo.vue?vue&type=style&index=0&id=8b6231b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6231b6",
  null
  
)

export default component.exports